import Swal from "sweetalert2";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { const_routes } from "../helpers/const_routes";
import { t } from "i18next";
import { startLogout } from "./authActions";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";
import { filterMenusByRuntimeFlags } from "../helpers/flowEngineConfigHelper";

export const startGetMenus = (menus) => {
  return async (dispatch, getState) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_MENU}`,
      "getByGroupsIncludeChildrenR",
      menus,
      `POST`
    );
    const body = await resp.json();

    if (body.ok) {

      const configurationState = getState()?.configuration || {};
      const menus = filterMenusByRuntimeFlags(body.menus.flat(), configurationState, getState()?.userRole);

      dispatch(getMenus(menus));

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startGetMenus_Step3 = (userRole, user_id) => {
  return async (dispatch, getState) => {

    const data = { userRole, user_id }

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_MENU}`,
      "getByUserIdRolesModulesIncludeChildrenRMenuR",
      data,
      `POST`
    );
    const body = await resp.json();

    if (body.ok) {

      const configurationState = getState()?.configuration || {};
      const menus = filterMenusByRuntimeFlags(body.menus.flat(), configurationState, getState()?.userRole);

      dispatch(getMenus(menus));

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const setIsLoadingMenuPaths = (menus) => ({
  type: types.MENU_IS_LOADING_PATHS,
  payload: menus,
});

export const setIsReLoadingMenuFromUrl = (menus) => ({
  type: types.MENU_IS_RELOADING_FROM_URL,
  payload: menus,
});

export const getMenus = (menus) => ({
  type: types.MENU_GROUP_ROLE,
  payload: menus,
});

export const setMenuPathsForCompare = (menus) => ({
  type: types.MENU_PATH_FOR_COMPARE,
  payload: menus,
});
/*
const getPanel = (panel) => ({
  type: types.MENU_PANEL,
  payload: panel,
});

const getAdministrator = (administrator) => ({
  type: types.MENU_ADMINISTRATOR,
  payload: administrator,
});

const getTechnical = (technical) => ({
  type: types.MENU_TECHNICAL,
  payload: technical,
});

const getClient = (client) => ({
  type: types.MENU_CLIENT,
  payload: client,
});
*/

/* Se agregan en adelante metodos normales */

export const startLoadingMenus = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_MENU}`, "get");
    const body = await resp.json();

     debugLogActions(':: menuActions, startLoadingMenus', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingMenus(body.menus));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingMenus = (menus) => ({
  type: types.MENU_START_LOADING,
  payload: menus,
});

export const startLoadingMenusPaginated = (page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_MENU}`, `get/${page}/${size}`);
    const body = await resp.json();

     debugLogActions(':: menuActions, startLoadingMenusPaginated', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingMenusPaginated(body.menuPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingMenusPaginated = (menuPaginated) => ({
  type: types.MENU_START_LOADING_PAGINATED,
  payload: menuPaginated,
});

export const selectMenus = (menu) => ({
  type: types.MENU_SELECT,
  payload: menu,
});

export const menuClean = () => ({
  type: types.MENU_CLEAN,
});

export const menuStartDelete = (id) => {
  return async (dispatch) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_MENU}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {

               debugLogActions(':: menuActions, menuStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(menuDeleted(id));
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: menuActions, menuStartDelete', { 'error': error });
    }
  };
};

const menuDeleted = (id) => {
  return {
    type: types.MENU_DELETE,
    payload: id,
  };
};

export const startSearchingMenusPaginated = (textSearch, page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_MENU}`,
      `search/${textSearch}/${page}/${size}`
    );
    const body = await resp.json();

     debugLogActions(':: menuActions, startSearchingMenuPaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingMenusPaginated(body.menusPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const searchingMenusPaginated = (menusPaginated) => ({
  type: types.MENU_START_SEARCH_PAGINATED,
  payload: menusPaginated,
});

export const cleanSearchingMenusPaginated = () => ({
  type: types.MENU_CLEAN_SEARCH_PAGINATED,
});

export const menuStartUpdate = (menu, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_MENU}`,
        `update/${menu.id}`,
        menu,
        "PUT"
      );
      const body = await resp.json();

       debugLogActions(':: menuActions, menuStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(menuUpdated(menu));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate("/admin-menu");
            }, 5000);
          }
        });

      } else {
        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: menuActions, menuStartUpdate', { 'error': error });
    }
  };
};

/**
 * Funcion para actualizar un evento en el store
 * @param {*} menu
 * @returns
 */
const menuUpdated = (menu) => {
  return {
    type: types.MENU_UPDATE,
    payload: menu,
  };
};

export const menuStartRegister = (menu, navigate) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_MENU}`,
      "add",
      menu,
      "POST"
    );

    const body = await resp.json();

     debugLogActions(':: menuActions, menuStartRegister', { 'body': body });

    if (body.ok) {
      dispatch(menuRegister(body.menu));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/admin-menu");
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const menuRegister = (menu) => ({
  type: types.MENU_START_REGISTER,
  payload: menu,
});

export const menuSetSearchText = (searchText) => ({
  type: types.MENU_SET_SEARCH_TEXT,
  payload: searchText,
});

export const menuCleanSearchText = () => ({
  type: types.MENU_SET_SEARCH_TEXT,
});

/** Revision */
export const startLoadingMenusAll = (type) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_MENU}`, `get`);
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingMenuAll(body.menus));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const loadingMenuAll = (menus) => ({
  type: types.MENU_START_LOADING_ALL,
  payload: menus,
});